import * as React from "react"
import { SkipNavContent, SkipNavLink } from "./skip-nav"
import { Header } from "./header"
import { Footer } from "./footer"
import { background, backgroundOverlay, video } from "../pages/index.module.css"

export function Layout({ children }) {
  const videoEl = React.useRef(null);
  React.useEffect(() => {
    videoEl.current.play()
  }, []);

  return (
    <div>
      <div className={background}>
        <video ref={videoEl} className={video} autoPlay={true} loop={true} muted={true} playsInline={true} crossOrigin={'anonymous'}>
          <source src="https://cdn.shopify.com/videos/c/o/v/aa346a66ddd44ac6b56224b90a15ad10.mp4" type="video/mp4" />
          <img decoding="async" src="https://cdn.shopify.com/s/files/1/0059/4867/0022/files/ambient-loop-for-web.jpg?v=1675646744" alt="" />
        </video>
        <div className={backgroundOverlay} />
      </div>
      <SkipNavLink />
      <Header />
      <SkipNavContent>{children}</SkipNavContent>
      <Footer />
    </div>
  )
}